export default function CTABanner() {
  return (
    <section className="cta-banner" aria-label="Call to action">
      <div className="cta-inner">
        <h2 className="cta-title">Ready to Transform Your Garden?</h2>
        <p className="cta-sub">Join thousands of happy farmers and gardeners across India. Try Paras Organics today with easy UPI payments and free pan-India delivery.</p>
        <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap'}}>
          <a href="/vermicompost" className="btn-primary" style={{background:'var(--green-dark)'}}>Shop Vermicompost</a>
          <a href="/vermiwash" className="btn-primary" style={{background:'#1a4d1e'}}>Shop Vermiwash</a>
        </div>
      </div>
    </section>
  );
}

